import type { Canale } from './canale';
import type { Generatore } from './impianto';
import type { QualitaLettura } from './telemetria';

/** Ruoli (specifica tecnica §3). */
export type Ruolo = 'residente' | 'residente_ospite' | 'tecnico' | 'admin';

export interface CredenzialiTecnico {
  utente: string;
  password: string;
}

export interface SessioneTecnica {
  /** Opaco: lo verifica la centralina/il cloud a ogni richiesta (RNF-22). */
  token: string;
  operatore: string;
  ruolo: Extract<Ruolo, 'tecnico' | 'admin'>;
  /** Scadenza assoluta: viene prorogata a ogni azione (RNF-25). */
  scadenza: number;
}

/** Inattività oltre la quale la sessione tecnica scade (RNF-25). */
export const INATTIVITA_SESSIONE_MS = 10 * 60_000;

/** Valore grezzo e convertito di un canale (RF-31). */
export interface LetturaCanale {
  canale: Canale;
  grezzo: number | null;
  convertito: number | null;
  q: QualitaLettura;
  ts: number;
}

/** Voce del registro interventi: in sola aggiunta (RF-36, RNF-24). */
export interface VoceRegistro {
  id: string;
  ts: number;
  operatore: string;
  azione: string;
  oggetto: string;
  prima: string | null;
  dopo: string | null;
}

export interface RichiestaForzatura {
  canale: string;
  stato: 'attivo' | 'spento';
  modulazione?: number;
  /** Obbligatorio: il timeout è imposto dalla centralina (RF-35). */
  timeoutSec: number;
}

export const TIMEOUT_FORZATURA_SEC: readonly number[] = [60, 300, 600];

export type FaseOta = 'inattivo' | 'pubblicazione' | 'rollout' | 'conferma' | 'completato' | 'rifiutato' | 'rollback';

export interface StatoOta {
  versioneCorrente: string;
  versioneDisponibile: string | null;
  versionePrecedente: string | null;
  fase: FaseOta;
  avanzamentoPct: number;
  firmata: boolean;
  ultimoEsito?: string;
}

export interface PatchCanale {
  assegnazione?: Canale['assegnazione'];
  tipoSonda?: Canale['tipoSonda'];
  taratura?: Partial<Canale['taratura']>;
}

export type PatchGeneratori = Generatore[];
